import { Injectable } from '@angular/core';
import { AyudaChannel, AyudaFormSubmitEvent } from 'ras-ayuda';
import { take } from 'rxjs';
import { AyudaDataService } from '../../shared/service/data/ayuda-data.service';
import { GtmDatalayerUiService } from '../../shared/service/ui/gtm-datalayer-ui.service';

@Injectable({
  providedIn: 'root'
})
export class AyudaClientService {
  constructor(
    private ayudaDataService: AyudaDataService,
    private gtmDataLayerUiService: GtmDatalayerUiService
  ) {}

  public handleChannelSelection(channel: AyudaChannel) {
    switch (channel) {
      case AyudaChannel.Chat:
        // Data Layer and Other Entries
        this.gtmDataLayerUiService.addAyudaFormEvent('chat', null).pipe(take(1)).subscribe();
        break;
      case AyudaChannel.WhatsApp:
        // Data Layer and Other Entries
        this.gtmDataLayerUiService.addAyudaFormEvent('whatsapp', null).pipe(take(1)).subscribe();
        break;
      default:
        break;
    }
  }

  public handleFormRequest(event: AyudaFormSubmitEvent): void {
    if (event.channel === AyudaChannel.CallMeBack) {
      this.gtmDataLayerUiService.addAyudaFormEvent('tellamamos', event.formData).pipe(take(1)).subscribe();

      this.ayudaDataService.saveCmbRequest(event.formData).pipe(take(1)).subscribe();
    } else if (event.channel === AyudaChannel.Email) {
      this.gtmDataLayerUiService.addAyudaFormEvent('email', event.formData).pipe(take(1)).subscribe();

      this.ayudaDataService.saveEmailRequest(event.formData).pipe(take(1)).subscribe();
    }
  }
}
